import dayjs from 'dayjs';

export const formatDate = (date) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format('Do MMM YYYY')
}

export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return "";
  }
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
}
